// extracted by mini-css-extract-plugin
export default {"base":"CardTitle_base__8AXpP","separator":"CardTitle_separator__IKm2m","small":"CardTitle_small__CTCng"};